<template lang="html">
  <div class="container" :class="{'filter':isFilter}">

      <div class="top">
        <p :class="{'yes': tabType == 1 }" @click="changeTab(1)">业务</p>
        <p :class="{'yes': tabType == 2 }" @click="changeTab(2)">制作</p>
        <p :class="{'yes': tabType == 3 }" @click="changeTab(3)">阿米巴</p>
      </div>

      <router-view  v-on:inFilter="inFilter" v-on:noFilter="noFilter"></router-view>

  </div>
</template>

<script>
import config from '../fetch/config'

export default {
  data () {
    return {
      tabType:1,
      isFilter:false,
    }
  },
  methods:{
    changeTab (type) {
      this.tabType = type
      if ( type == 1 ) {//业务数数据
        this.$router.push({ name:'businessmon'})
      } else if ( type == 3 ) {//阿米巴
        this.$router.push({ name:'project'})
      } else {//制作数据
        this.$router.push({ name:'make'})
      }
      window.localStorage.removeItem('drillData')
    },
    inFilter () {
      this.isFilter = true
    },
    noFilter () {
      this.isFilter = false
    }
  },
  watch: {
    '$route.name': function () {
      switch (this.$route.name) {
        case 'project':
          this.tabType = 3
          break
        case 'businessmon':
          this.tabType = 1
          break
        case 'businessyear':
          this.tabType = 1
          break
        case 'make':
          this.tabType = 2
          break
      }
    },
  },
  created () {
    switch (this.$route.name) {
      case 'project':
        this.tabType = 3
        break
      case 'businessmon':
        this.tabType = 1
        break
      case 'businessyear':
        this.tabType = 1
        break
      case 'make':
        this.tabType = 2
        break
    }
  },

}
</script>

<style lang="css" scoped>
  html, body{
    height: 100%;
  }
  .container {
    width: 100%;
    /*height: 100%;*/
    background-color: #fafafa;
  }
  .container.filter{
    height: 100%;
    overflow: hidden;
  }
  .yes{
    background: #5483D2;
    color: #fff;
  }
  .top{
    width: 85%;
    border: 1px solid #5483D2;
    color: #737171;
    font-size: 0;
    margin: auto;
    margin-top: 0.25rem;
    border-radius: 0.09375rem;
    margin-bottom: 0.25rem;
  }
  .top p{
    font-size: 0.4375rem;
    display: inline-block;
    width: 33.3%;
    text-align: center;
    border-right: 1px solid #5483D2;
    padding: 0.125rem;
  }
  .top p:last-child{
    border:0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Business.vue